import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["styles"];

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

import React from "react";
export default (function (_ref) {
  var _ref$styles = _ref.styles,
      styles = _ref$styles === void 0 ? {} : _ref$styles,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 17.9999v3H4.0001V18.025C4.00003 18.0167 4 18.0083 4 17.9999c0-1.835 1.58699-3.435 3.94498-4.305 1.14599.818 2.54302 1.305 4.05492 1.305 1.512 0 2.909-.487 4.055-1.305 2.358.87 3.9451 2.47 3.9451 4.305zm-3-9.99993c0 2.76103-2.239 4.99993-5 4.99993-2.76093 0-4.99992-2.2389-4.99992-4.99993C7.00008 5.23899 9.23907 3 12 3c2.761 0 5 2.23899 5 4.99997z",
    fill: "currentColor"
  }));
});